export const faqs = [
  {
    'id': 1,
    'question': 'What does it mean to be on-chain encoded?',
    'answer': 'Having our Avime be entirely encoded on-chain means that all the data and images used to create your Avime and their traits live directly on the Ethereum blockchain, attached to our custom built smart contract. This means that there is no requirement for Avime assets to be hosted on services such as IPFS or centralized servers. This means that your Avime is an immortal and native resident of Ethereum that will be backed by the robust security the network can provide.',
  },
  {
    'id': 2,
    'question': 'What do you mean no IPFS?',
    'answer': 'The source of the Avime images and data are recorded entirely on the Ethereum blockchain, through our unique smart contract. Which means ownership of an Avime, and the image itself, are fully on-chain.',
  },
  {
    'id': 3,
    'question': 'How are they customizable?',
    'answer': 'We created Avime with the intent for everyone to make characters that truly resonate with them. Avime allows you to mix and match your character the way that you want. There will be two smart contracts: an initial minting contract and a fusion contract. When minting, you’ll receive 6 individual traits that are required for creating an Avime; a background, body, face, clothes, hair, and accessory. Each trait is its own NFT that can be bought, sold, or traded on the open market. When you’ve collected the traits you want to use, you can fuse them together to mint your Avime! All traits are burned in the process, and there will only ever be enough traits to create 10k Avime, so choose wisely and make sure your combination is the one you really want. All assets including your finished Avime are stored directly on chain!',
  },
  {
    'id': 4,
    'question': 'Wen mint? How much?',
    'answer': 'Mint price and drop date are currently TBD.',
  },
  {
    'id': 5,
    'question': 'Can I pick my body when customizing?',
    'answer': 'Yes! Before fusing your Avime you will have the choice to pick between male and female body frames. The same traits can be used on both body types, but alter its appearance accordingly..',
  },
  {
    'id': 6,
    'question': 'Can I preview my avime before fusion?',
    'answer': 'Definitely. Our site will allow you to mix and match different traits present in your wallet. You don\'t have to fuse your traits before seeing the outcome, meaning there\'s no guesswork in deciding how traits will work together.',
  },
  {
    'id': 7,
    'question': 'Can I kiss my Avime?',
    'answer': 'It\'s your Avime, we won\'t judge!',
  },
  {
    'id': 8,
    'question': 'Can you make an Avime of Best Girl Rei Ayanami, so I can kiss her every day and night???',
    'answer': 'We won\'t have exact 1/1 character parts for copyright reasons but we definitely have parts that can give you the look and feel of some of your favorite parts if you arrange them creatively. We wanted to include many different tropes, archetypes, and styles to help you create Avime with the look and feel you\'re aiming for.',
  },
];
